// extracted by mini-css-extract-plugin
module.exports = {"main":"sk-CardBodyHeader_main__9_8dW"};